import { useEffect, useState } from "react";
import { getAuth, onIdTokenChanged } from "firebase/auth";
import { AuthContext } from "./auth";

export function AuthProvider({ children }) {
    const auth = getAuth();
    const [user, setUser] = useState(null);
    const [claims, setClaims] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsubscribe = onIdTokenChanged(auth, async (user) => {
            if (!user) {
                setUser(null);
                setClaims(null);
                setLoading(false);
                return;
            }

            setUser(user);

            const token = await user.getIdTokenResult();

            if (token.claims?.clinician) setClaims("clinician");
            if (token.claims?.patient) setClaims("patient");

            setLoading(false);
        });

        return () => unsubscribe();
    }, [auth]);

    return (
        <AuthContext.Provider value={{ user, claims, loading }}>
            {children}
        </AuthContext.Provider>
    );
}
